/* src/app/modules/employees/gastos/gastos.component.css */
:host {
  --gs-brand: #e3fd64;
  --gs-brand-d: #4d7a00;
  --gs-text: #1a1d23;
  --gs-muted: #6b7280;
  --gs-border: #e5e7eb;
  --gs-surface: #ffffff;
  --gs-radius: 10px;
  --gs-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.gs-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.gs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.gs-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.gs-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.gs-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.gs-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--gs-text);
  line-height: 1.2;
}
.gs-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--gs-muted);
}
.gs-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gs-btn-primary {
  background-color: var(--gs-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.gs-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--gs-muted) !important;
}
.gs-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.gs-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.gs-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--gs-brand);
}
.gs-loading__dots {
  display: flex;
  gap: 8px;
}
.gs-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--gs-brand);
  opacity: 0.3;
  animation: gs-pulse 1.2s ease-in-out infinite;
}
.gs-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.gs-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.gs-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--gs-muted);
}
@keyframes gs-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.gs-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gs-section__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}
.gs-pill {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--gs-brand);
  flex-shrink: 0;
  position: relative;
  top: -1px;
}
.gs-pill--blue {
  background: #3b82f6;
}
.gs-section__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--gs-text);
}
.gs-section__sub {
  margin: 0;
  font-size: 12.5px;
  color: var(--gs-muted);
}
.gs-card {
  background: var(--gs-surface);
  border-radius: var(--gs-radius);
  box-shadow: var(--gs-shadow);
  border: 1px solid var(--gs-border);
  overflow: hidden;
}
.gs-table {
  width: 100%;
}
.gs-table th.mat-mdc-header-cell {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--gs-muted);
  background: #f9fafb;
  border-bottom: 1px solid var(--gs-border);
  padding: 12px 16px;
  white-space: nowrap;
}
.gs-table td.mat-mdc-cell {
  padding: 13px 16px;
  font-size: 13px;
  color: var(--gs-text);
  border-bottom: 1px solid var(--gs-border);
  vertical-align: middle;
}
.gs-row:last-child td.mat-mdc-cell {
  border-bottom: none;
}
.gs-row:hover td.mat-mdc-cell {
  background: #fafafa;
}
.gs-cell-employee {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gs-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--gs-brand-d);
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
}
.gs-date {
  font-size: 12.5px;
  color: var(--gs-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.gs-filename {
  font-weight: 500;
  font-size: 13px;
}
.gs-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(227, 253, 100, 0.1);
  color: #a07500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.gs-path {
  font-size: 11.5px;
  color: var(--gs-muted);
  font-family: monospace;
}
.gs-check {
  display: inline-flex;
  align-items: center;
}
.gs-check mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #16a34a;
}
.gs-pending {
  font-size: 11.5px;
  color: var(--gs-muted);
  font-style: italic;
}
.gs-amount {
  font-weight: 600;
  font-size: 13px;
  color: #15803d;
  font-variant-numeric: tabular-nums;
}
.gs-col-actions {
  width: 52px;
  text-align: right !important;
  padding-right: 12px !important;
}
.gs-menu-trigger {
  opacity: 0;
  transition: opacity 0.15s;
}
.gs-row:hover .gs-menu-trigger {
  opacity: 1;
}
.gs-filter-card {
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius);
  box-shadow: var(--gs-shadow);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gs-filter-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gs-text);
}
.gs-filter-card__icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--gs-brand);
}
.gs-filter-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.gs-filter-field {
  flex: 1;
  min-width: 220px;
}
.gs-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
  flex-shrink: 0;
}
.gs-stat-card {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: rgba(21, 128, 61, 0.06);
  border: 1px solid rgba(21, 128, 61, 0.2);
  border-radius: var(--gs-radius);
  align-self: flex-start;
}
.gs-stat-card__icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #15803d;
}
.gs-stat-card__label {
  margin: 0;
  font-size: 11.5px;
  color: var(--gs-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}
.gs-stat-card__value {
  margin: 2px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: #15803d;
  font-variant-numeric: tabular-nums;
}
.gs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 24px;
  text-align: center;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius);
}
.gs-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.1);
}
.gs-empty__art mat-icon {
  font-size: 30px;
  width: 30px;
  height: 30px;
  color: var(--gs-brand);
}
.gs-empty__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--gs-text);
}
.gs-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--gs-muted);
  max-width: 320px;
}
.gs-action-danger,
.gs-action-danger mat-icon {
  color: #dc2626 !important;
}
.gs-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
/*# sourceMappingURL=gastos.component.css.map */
